import styled from 'styled-components';

const Body7 = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #232d3a;
`;

export default Body7;
